import _axios from '@/plugins/axios';
import { RepoError } from '../../../lib/Errors';

export default {
	async getReportByOrganization ({ organizationId, byMonth, byYear }) {
		try {
			const response = await _axios.get('/audit/getReportByOrganization', {
				headers: { organizationId, byMonth, byYear },
			});
			if (response.data.statusCode === 200) {
				return response.data;
			}
		} catch (error) {
			throw new RepoError('Error getting audit report by organization');
		}
	},
	async getByMedicalStaffId ({ staffId, byMonth, byYear }) {
		try {
			const response = await _axios.get(`/audit/getByMedicalStaffDByMonth/${staffId}`, {
				headers: { byMonth, byYear },
			});
			if (response.data.statusCode === 200) {
				return response.data;
			}
		} catch (error) {
			throw new RepoError('Error getting audit report by medical staff');
		}
	},
	async getByMedicalStaffIdByHospitalId ({ staffId, hospitalId, byMonth, byYear }) {
		try {
			const response = await _axios.get(`/audit/getByMedicalStaffDByHospitalIdByMonth/${staffId}/${hospitalId}`, {
				headers: { byMonth, byYear },
			});
			if (response.data.statusCode === 200) {
				return response.data;
			}
		} catch (error) {
			throw new RepoError('Error getting audit report by staff and hospital');
		}
	},
	async getByMedicalStaffIdByHospitalIdByPatientId ({ staffId, hospitalId, patientId, byMonth, byYear }) {
		try {
			const response = await _axios.get(
				`/audit/getByMedicalStaffDByHospitalIdByPatientIdByMonth/${staffId}/${hospitalId}/${patientId}`,
				{ headers: { byMonth, byYear } },
			);
			if (response.data.statusCode === 200) {
				return response.data;
			}
		} catch (error) {
			throw new RepoError('Error getting audit report by staff, hospital, and patient');
		}
	},
};
